import { EllipsisTextWithTooltip } from "@shape-ds/components";
import { KeyPrefix } from "i18next";
import { dayjs } from "../../lib";
import {
  FallbackNs,
  useTranslation,
  UseTranslationOptions,
} from "react-i18next";
import { isValidDate, removeUnderline } from "../../utils";

export const DefaultCell = ({
  className,
  i18nkey,
  i18nParams,
  text,
}: {
  className?: string;
  i18nkey?: string;
  i18nParams?: UseTranslationOptions<KeyPrefix<FallbackNs<string>>>;
  text?: string | null;
}) => {
  const { t } = useTranslation();

  if (!text || text === "") {
    return <span className={className ?? "cell-no-content"}>-</span>;
  }

  if (isValidDate(text)) {
    return (
      <span className={className}>
        {dayjs(text.trim()).format(t("formats:date.lts"))}
      </span>
    );
  }
  const textClean = removeUnderline(text);
  const content = i18nkey
    ? t(`${i18nkey}.${text}`, { defaultValue: textClean, ...i18nParams })
    : textClean;

  return <EllipsisTextWithTooltip text={content} className={className} />;
};
